import useClientState from '@/state/useClientState';

import WtsTableRow from './WtsTableRow';

import styles from './WtsTable.module.css';
const WtsTable = () => {
  const wtsEenheden = useClientState((state) => state.wtsEenheden);
  return (
    <div className={styles.wtsTableContainer}>
      <div className={styles.wtsTableHeadersRow}>
        <div className={styles.wtsHeaderEenheid}>Eenheid</div>
        <div className={styles.wtsHeaderDatumDelete}>Datum aangemaakt</div>
      </div>
      {wtsEenheden.map((wtsEenheid) => (
        <WtsTableRow key={wtsEenheid.nummer} wtsEenheid={wtsEenheid} />
      ))}
    </div>
  );
};
export default WtsTable;
